module.exports = __webpack_public_path__ + "static/media/72.866de8ec.jpg";